import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import { ApiVisa } from '../shared';

// /core2/tnt/dm/applet-login-subject-link/create-multiple/tenant-ep

@Injectable({providedIn: 'root'})
export class AppLoginSubjectLinkTenantService extends BaseApiTemplateService<any> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'applet-login-subject-link/create-multiple/tenant-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'applet-login-subject-link/create-multiple/tenant-ep';
    this.httpClient = http;
  }


  // core2/tnt/dm/applet-login-subject-link/delete-multiple/tenant-ep

  public deleteMultiple(dtoObject: any, visa: ApiVisa){
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'applet-login-subject-link/delete-multiple/tenant-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'applet-login-subject-link/delete-multiple/tenant-ep';
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    
    let httpOptions = this.getHttpHeader(visa);
    httpOptions.headers = httpOptions.headers.set("Content-Type", "application/json");

    // Use httpClient.request to send a DELETE request with a body
    return this.httpClient.request('delete', this.apiUrl, {
      ...httpOptions,
      body: dtoObject
    });
  }
}
